import { Component, AfterContentInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { AppBarTitleService, OfferCalculatorService, ProductCode } from 'common';
import { BaseCalculatorComponent } from '../base/base-calculator.component';
import * as _ from 'lodash';
import { AppSettings } from '../../../app.settings';
import { CurrencyPipe, PercentPipe } from '@angular/common';
import { OfferBundleService } from '../../shared/offer-bundle.service';
import { ApplicationService } from '../../shared/application.service';

@UntilDestroy()
@Component({
    selector: 'ifa-term-calculator',
    templateUrl: './term-calculator.component.html',
    styleUrls: ['./../base/base-calculator.component.scss', './term-calculator.component.scss'],
    standalone: false
})
export class TermCalculatorComponent extends BaseCalculatorComponent implements AfterContentInit {

  constructor(
    private route: ActivatedRoute,
    sanitizer: DomSanitizer,
    appBarTitleService: AppBarTitleService,
    calculatorService: OfferCalculatorService,
    applicationService: ApplicationService,
    settings: AppSettings,
    percentPipe: PercentPipe,
    currencyPipe: CurrencyPipe,
    _offerBundleService: OfferBundleService
  ) {
    super(route, sanitizer, appBarTitleService, calculatorService, applicationService, settings, percentPipe, currencyPipe);
  }

  ngAfterContentInit(): void {
    this.setAppBarTitle('See all products');
  // @ts-ignore - TODO: Refactor to align with "@types/lodash" typings - RYNO-12167
  this._calculatorService.bundleChanged.pipe(untilDestroyed(this)).subscribe(bundle => this.offer = _.first(bundle?.offers, { productCode: ProductCode.Term }));
  }
}
